import { Component, Input, OnInit } from '@angular/core';
import { CoreService } from 'src/app/modules/core/services/core.service';
import { SocialHelper } from '@app/store/models/social-helper.interface';
import { FunctionsService } from 'src/app/modules/core/services/functions.service';
import { QrGeneratorNavigatorVCARDPRO, DynamicQrPageThemeType } from 'shared-library';
import { UserQrGeneratorService } from '@app/modules/user/services/user-qr-generator.service';

@Component({
  selector: 'app-qrs-vcard-pro',
  templateUrl: './qrs-vcard-pro.component.html',
  styleUrls: [
    './qrs-vcard-pro.component.scss',
    './qrs-vcard-pro-ThemeType1.component.scss',
    './qrs-vcard-pro-ThemeType2.component.scss',
    './qrs-vcard-pro-ThemeType3.component.scss',
    './qrs-vcard-pro-ThemeType4.component.scss',
    './qrs-vcard-pro-ThemeType5.component.scss',
    './qrs-vcard-pro-ThemeType6.component.scss',
    './qrs-vcard-pro-ThemeType7.component.scss',
    './qrs-vcard-pro-ThemeType8.component.scss',
    './qrs-vcard-pro-ThemeType9.component.scss',
    './qrs-vcard-pro-ThemeType10.component.scss',
    './qrs-vcard-pro-ThemeType11.component.scss',
    './qrs-vcard-pro-ThemeType12.component.scss',
    './qrs-vcard-pro-ThemeType13.component.scss',
    './qrs-vcard-pro-ThemeType14.component.scss',
    './qrs-vcard-pro-ThemeType15.component.scss',
    './qrs-vcard-pro-ThemeType16.component.scss',
    './qrs-vcard-pro-ThemeType17.component.scss',
    './qrs-vcard-pro-ThemeType18.component.scss',
    '../qrs-wrapper.component.scss'
  ]
})
export class QrsVcardProComponent implements OnInit {

  @Input() qr_url: string;
  @Input() social_data: SocialHelper
  @Input() data: QrGeneratorNavigatorVCARDPRO

  ThemeTypes = {
    ThemeType1: DynamicQrPageThemeType.ThemeType1,
    ThemeType2: DynamicQrPageThemeType.ThemeType2,
    ThemeType3: DynamicQrPageThemeType.ThemeType3,
    ThemeType4: DynamicQrPageThemeType.ThemeType4,
    ThemeType5: DynamicQrPageThemeType.ThemeType5,
    ThemeType6: DynamicQrPageThemeType.ThemeType6,
    ThemeType7: DynamicQrPageThemeType.ThemeType7,
    ThemeType8: DynamicQrPageThemeType.ThemeType8,
    ThemeType9: DynamicQrPageThemeType.ThemeType9,
    ThemeType10: DynamicQrPageThemeType.ThemeType10,
    ThemeType11: DynamicQrPageThemeType.ThemeType11,
    ThemeType12: DynamicQrPageThemeType.ThemeType12,
    ThemeType13: DynamicQrPageThemeType.ThemeType13,
    ThemeType14: DynamicQrPageThemeType.ThemeType14,
    ThemeType15: DynamicQrPageThemeType.ThemeType15,
    ThemeType16: DynamicQrPageThemeType.ThemeType16,
    ThemeType17: DynamicQrPageThemeType.ThemeType17,
    ThemeType18: DynamicQrPageThemeType.ThemeType18,
  }

  constructor(
    public readonly coreService: CoreService,
    public readonly functionService: FunctionsService,
    public qrGeneratorService: UserQrGeneratorService
  ) { }

  ngOnInit(): void {
    this.functionService.initializeTooltip()
    this.deepAddStyleToQuillOutput()
  }

  private deepAddStyleToQuillOutput() {
    if (![
      DynamicQrPageThemeType.ThemeType1
    ].includes(this.data.theme.type)) {
      setTimeout(() => {
        const tempDiv = document.getElementById('ql-editor')
        if (tempDiv) {
          let textAlign = [
            DynamicQrPageThemeType.ThemeType4,
            DynamicQrPageThemeType.ThemeType11,
            DynamicQrPageThemeType.ThemeType13,
            DynamicQrPageThemeType.ThemeType14,
            DynamicQrPageThemeType.ThemeType15,
            DynamicQrPageThemeType.ThemeType17,
          ].includes(this.data.theme.type) ? 'left' : 'center';

          if ([
            DynamicQrPageThemeType.ThemeType16,
          ].includes(this.data.theme.type)) {
            textAlign = 'right';
          }

          const color = [
            DynamicQrPageThemeType.ThemeType4,
            DynamicQrPageThemeType.ThemeType7,
            DynamicQrPageThemeType.ThemeType10,
            DynamicQrPageThemeType.ThemeType14,
          ].includes(this.data.theme.type) ? this.data.colors.secondary_color : this.data.colors.text_color;

          tempDiv.childNodes.forEach((node: HTMLElement) => {
            if (node.nodeType === Node.TEXT_NODE) {
              const parentEl = node.parentNode as HTMLElement;
              parentEl.style.textAlign = textAlign;
              parentEl.style.color = color;
            } else {
              node.style.textAlign = textAlign;
              node.style.color = color;
            }
          });
        }
      })
    }
  }
}
